import { render } from "./ModernAbout.vue?vue&type=template&id=26970694&scoped=true"
import script from "./ModernAbout.vue?vue&type=script&lang=js"
export * from "./ModernAbout.vue?vue&type=script&lang=js"

import "./ModernAbout.vue?vue&type=style&index=0&id=26970694&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26970694"]])

export default __exports__